import $ from 'jquery'
import {
    prepareChessboard,
    showMagnus,
    validateMove,
    restrictMove,
    loadNextConfiguration,
    showCapturedPieces,
    hideCapturedPieces
} from '../../utils'
import ChessBoard from '../../components/chessBoard';
import { CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO } from '../../utils/constants';

var tableValues = [];

/**
 * @name notationTable
 * @function
 * @param { config }
 * @description Student makes move according to Notation Table.
 */

export function notationTable(config) {
    let next = config.next,
        moveSpeed = 1000,
        initialBoardPosition = config.position,
        moves = config.moves,
        totalStudentMoves = config.moves.studentMove.from.length,
        totalComputerMoves = config.moves.computerMove.from.length,
        studentFromCount = 0,
        studentToCount = 0,
        computerFromCount = 0,
        computerToCount = 0,
        board, timer;

    let afterLoad = function () {
        prepareChessboard(config);
        $(function () {
            $('.directions').css('width', '100%');
        })
        if (config.firstMove) {
            computerMove();
        }
    }

    let onDragStart = function (source, piece, position, orientation) {
        board = ChessBoard.board.fen();
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        $('.next-btn-container #next').click(function () {
            studentFromCount = 0;
            studentToCount = 0;
            clearTimeout(timer);
        });
        $('.back-btn-container #previous').click(function () {
            studentFromCount = 0;
            studentToCount = 0;
            clearTimeout(timer);
        })
        if (studentFromCount < totalStudentMoves && studentToCount < totalStudentMoves) {
            if (source === moves.studentMove.from[studentFromCount] && target === moves.studentMove.to[studentToCount]) {
                $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
                $(document).trigger('bubble-hide');
                studentFromCount++;
                studentToCount++;
                computerMove();
            } else {
                $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
                showMagnus({
                    data: 'That\'s not the right move',
                    position: 'left',
                    styleClass: 'md'
                })
                setTimeout(function () {
                    $(document).trigger('bubble-hide');
                }, 3000)
                ChessBoard.board.position(board);
                ChessBoard.game = new window.Chess(board + config.initialMoveOf);
            }
        }
    }

    function computerMove() {
        if (computerFromCount < totalComputerMoves && computerToCount < totalComputerMoves) {
            timer = setTimeout(function () {
                ChessBoard.board.move(moves.computerMove.from[computerFromCount] + '-' + moves.computerMove.to[computerToCount]);
                computerFromCount++;
                computerToCount++;
            }, 2000);
            $('.next-btn-container #next').click(function () {
                computerFromCount = 0;
                computerToCount = 0;
                clearTimeout(timer);
            });
            $('.back-btn-container #previous').click(function () {
                computerFromCount = 0;
                computerToCount = 0;
                clearTimeout(timer);
            })
        }
        if (!moves.computerMove.from[computerFromCount]) {
            setTimeout(function () {
                studentFromCount = studentToCount = computerFromCount = computerToCount === 0;
                showMagnus({
                    data: 'Good job!',
                    position: 'left'
                })
                ChessBoard.board.position(config.resultFen);
                loadNextConfiguration(3000, next, true);
            }, 2000);
        } else if (!moves.studentMove.from[studentFromCount]) {
            setTimeout(function () {
                loadNextConfiguration(1000, config.blackCastle, false);
            }, 2000)
        } else {
            let boardFen = ChessBoard.board.fen();
            ChessBoard.board.position(boardFen);
            ChessBoard.game = new window.Chess(boardFen + config.initialMoveOf);
        }
    }

    const chessConfig = {
        config: {
            position: initialBoardPosition,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            draggable: true,
            sparePieces: true,
            moveSpeed: moveSpeed
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
* @name activity3StudentMoveCastle
* @function
* @param {config}
* @description: Student doing a Castle
*/

export function activity3StudentMoveCastle(config) {
    let next = config.next,
        moveCount = 0;

    let afterLoad = function () {
        prepareChessboard(config);
        $(function () {
            $('.directions').css('width', '100%');
        })
    }

    let onSnapEnd = function (piece, square, position, orientation) {
        ChessBoard.game = new window.Chess(config.position + config.startChance);
    }

    var onSnapbackEnd = function (source, target, piece) {

    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        let move = ChessBoard.game.move({
            from: source,
            to: target,
        });

        if (piece.search("K") === -1 && piece.search("R") === -1) {
            return 'snapback'
        }

        if (piece.search("R") !== -1 && target === config.rookTarget) {
            // continue
        } else if (piece.search("R") !== -1 && move === null) {
            return 'snapback'
        }

        if (piece.search("K") !== -1 && target === config.kingTarget) {
            // continue
        } else if (piece.search("K") !== -1 && move === null) {
            return 'snapback'
        }

        moveCount = moveCount + 1;

        if (moveCount === 2) {
            if (window.ChessBoard.objToFen(newPos) !== config.finalPosition) {
                moveCount = 0;
                ChessBoard.board.position(config.position);
                return 'snapback'
            } else {
                moveCount = 0;
                showMagnus({
                    data: 'Good job!',
                    position: 'left'
                })
                loadNextConfiguration(3000, next, true)
            }
        }
    }
    const chessConfig = {
        config: {
            position: config.position,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            onSnapbackEnd: onSnapbackEnd,
            draggable: true,
            sparePieces: true
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name activity4ComputerMove
 * @function
 * @param { config }
 * @description: Student need to click on correct move.
 */

export function activity4ComputerMove(config) {
    let moveSpeed = 1000,
        from = config.from,
        to = config.to,
        position = config.position,
        body = '<button id="repeat-btn" type="button">Repeat Move</button>';

    let afterLoad = function () {
        prepareChessboard(config);
        $('.next-btn-container #next').click(function () {
            tableValues.length = 0;
            $(document).unbind('get-value');
        });
        $('.back-btn-container #previous').click(function () {
            tableValues.length = 0;
            $(document).unbind('get-value');
        })
        $('#chessBoard').css('pointer-events', 'none');
        $(document).trigger('table-show', [tableValues]);
        $(function () {
            if ($('#repeat-btn').length === 0) {
                $('.options').append(body);
            }
            if ($('#repeat-btn').length >= 2) {
                $('#repeat-btn').remove();
            }
            $(document).bind('get-value', update)
        })

        function update(e, value, flag) {
            tableValues.push(value);
            $(document).unbind('get-value');
            if (tableValues.length === 8 && flag) {
                showMagnus({
                    data: 'Nice job!',
                    position: 'left'
                })
                setTimeout(function () {
                    loadNextConfiguration(3000, config.next, true);
                }, 1000)
            } else if (!flag) {
                loadNextConfiguration(5000, config.next, false);
            } else if (flag) {
                loadNextConfiguration(1000, config.next, false);
            }
        }
        setTimeout(function () {
            ChessBoard.board.move(from + "-" + to);
            $('#repeat-btn').click(function () {
                hideCapturedPieces();
                ChessBoard.board.position(position);
                setTimeout(function () {
                    ChessBoard.board.move(from + "-" + to);
                    if (config.capture) {
                        let move = {
                            captured: config.capture.capturedPiece.charAt(1),
                            color: config.capture.capturingPiece.charAt(0)
                        }
                        setTimeout(function () {
                            showCapturedPieces(config.capture.capturingPiece, move, false)
                        }, moveSpeed)
                    }
                }, 2000)
            })
            if (config.capture) {
                let move = {
                    captured: config.capture.capturedPiece.charAt(1),
                    color: config.capture.capturingPiece.charAt(0)
                }
                setTimeout(function () {
                    showCapturedPieces(config.capture.capturingPiece, move, false)
                }, moveSpeed)
            }
        }, 1000);
    }

    const chessConfig = {
        config: {
            position: config.position,
            draggable: true,
            sparePieces: true,
            moveSpeed: moveSpeed
        },
        afterLoad: afterLoad,
    }
    return chessConfig;
}

/**
 * @name lesson11QA6
 * @function
 * @param { config }
 * @description: Question 6s Computer Move
 */

export function lesson11QA6(config) {
    let moveSpeed = 1000,
        initialBoardPosition = config.position,
        timer, repeatTimer,
        body = '<button class="repeat-btn-qa" type="button">Repeat Move</button>';

    let afterLoad = function () {
        prepareChessboard(config);
        if ($('.repeat-btn-qa').length === 0) {
            $('.right-box-content').append(body);
        }
        if ($('.repeat-btn-qa').length >= 2) {
            $('.repeat-btn-qa').remove();
        }
        $(function () {
            $('.spare-pieces-top-4028b').addClass('custom-margin');
            $('.custom-margin').css('margin-left', '6px').css('margin-top', '13px');
            $('.answer').click(function () {
                clearTimeout(timer); clearTimeout(repeatTimer);
                $('.repeat-btn-qa').css('opacity', '0');
                setTimeout(function () {
                    $('.repeat-btn-qa').remove();
                }, 4000)
            })
        })

        repeatTimer = setTimeout(function () {
            $('.repeat-btn-qa').click(function () {
                hideCapturedPieces();
                ChessBoard.board.position(initialBoardPosition);
                setTimeout(function () {
                    ChessBoard.board.move(config.from + "-" + config.to);
                    if (config.capture) {
                        let move = {
                            captured: config.capture.capturedPiece.charAt(1),
                            color: config.capture.capturingPiece.charAt(0)
                        }
                        setTimeout(function () {
                            showCapturedPieces(config.capture.capturingPiece, move, false)
                        }, moveSpeed)
                    }
                }, 2000)
            })
        }, 3000)

        $('.next-btn-container #next').click(function () {
            clearTimeout(timer); clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        });
        $('.back-btn-container #previous').click(function () {
            clearTimeout(timer); clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        })

        timer = setTimeout(function () {
            $('.repeat-btn-qa').css('cursor', 'pointer');
            ChessBoard.board.move(config.from + "-" + config.to);
            if (config.capture) {
                let move = {
                    captured: config.capture.capturedPiece.charAt(1),
                    color: config.capture.capturingPiece.charAt(0)
                }
                setTimeout(function () {
                    showCapturedPieces(config.capture.capturingPiece, move, false)
                }, moveSpeed)
            }
        }, 3000)
    }

    const chessConfig = {
        config: {
            position: initialBoardPosition,
            draggable: true,
            sparePieces: true,
            moveSpeed: moveSpeed
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson11QA8
 * @function
 * @param {config}
 * @description: Computer does a castle
 */

export function lesson11QA8(config) {
    let body = '<button class="repeat-btn-qa" type="button">Repeat Move</button>';

    let afterLoad = function () {
        prepareChessboard(config);
        if ($('.repeat-btn-qa').length === 0) {
            $('.right-box-content').append(body);
        }
        if ($('.repeat-btn-qa').length >= 2) {
            $('.repeat-btn-qa').remove();
        }
        $(function () {
            $('.answer').click(function () {
                clearTimeout(timer); clearTimeout(repeatTimer);
                $('.repeat-btn-qa').css('opacity', '0');
                setTimeout(function () {
                    $('.repeat-btn-qa').remove();
                }, 4000)
            })
        })

        let repeatTimer = setTimeout(function () {
            $('.repeat-btn-qa').click(function () {
                ChessBoard.board.position(config.position);
                setTimeout(function () {
                    ChessBoard.board.position(config.finalPosition);
                }, 2000)
            })
        }, 3000)

        $('.next-btn-container #next').click(function () {
            clearTimeout(timer); clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        });
        $('.back-btn-container #previous').click(function () {
            clearTimeout(timer); clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        })

        let timer = setTimeout(function () {
            $('.repeat-btn-qa').css('cursor', 'pointer');
            ChessBoard.board.position(config.finalPosition);
        }, 3000)
    }

    const chessConfig = {
        config: {
            position: config.position,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}



// WEBPACK FOOTER //
// ./src/lessons/lesson_11/assignments.js